module.exports = __webpack_public_path__ + "img/X.2b022275.svg";